<template>
  <ul class="c-list--checkup">
    <li class="c-list--checkup__item">
      <span class="c-list--checkup__label judgement">判定</span>
      <div class="c-list--checkup__content">
        <p v-if="!hasError">
          このサイトは現在、疑わしいものとしてリストされていません（マルウェアまたはフィッシング活動は見つかりません）。
        </p>
        <p v-else>
          このサイトは現在、疑わしいものとしてリストされています（マルウェアまたはフィッシング活動は見つかりました）。
        </p>
      </div>
    </li>
    <li v-if="hasError" class="c-list--checkup__item">
      <span class="c-list--checkup__label hint">ヒント</span>
      <div class="c-list--checkup__content">
        <p>
          ウェブサイトをマルウェアまたはフィッシングのファイルをスキャンして、削除しましょう。WordfenceやSecuriのツールでスキャンできます。
        </p>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      required: true
    },
    hasError: {
      type: Boolean,
      required: true
    }
  }
};
</script>
